import {DEFAULT_CALENDAR_CONFIG} from '@/views/calendar/calendar.defaults';
import moment from 'moment';
import {DUMMY_EVENTS} from '@/views/timeline/services/dummy-events';
import {EventType} from '@/views/timeline/services/events.types';
import {ISchedule} from 'tui-calendar';

class CalendarUtils {
    /**
     * Scrolls directly to the first time grid element configured
     */
    scrollToFirstBusinessHour() {
        const timeGridElements = this.findTimeGridElements();
        if (timeGridElements && timeGridElements.length) {
            const elementToScrollTo = timeGridElements[DEFAULT_CALENDAR_CONFIG.scrollToHour];
            if (elementToScrollTo && elementToScrollTo instanceof HTMLElement) {
                elementToScrollTo.scrollIntoView();
            }
        }
    }
    /**
     *  Non working hours will be grey
     */
    highlightBusinessHours() {
        const timeGridElements = this.findTimeGridElements();
        if (timeGridElements && timeGridElements.length) {
            const businessDayStart = DEFAULT_CALENDAR_CONFIG.businessDayStartHour;
            const businessDayEnd = DEFAULT_CALENDAR_CONFIG.businessDayEndHour;
            for (let timeGridElIndex = 0; timeGridElIndex < 24; timeGridElIndex++) {
                if (timeGridElIndex < businessDayStart || timeGridElIndex >= businessDayEnd) {
                    const currentTimeGridEl = timeGridElements[timeGridElIndex];
                    if (currentTimeGridEl && currentTimeGridEl instanceof HTMLElement) {
                        currentTimeGridEl.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
                    }
                }
            }
        }
    }

    /**
     * Used for random data generation
     */
    generateDummyData(day: Date): ISchedule[] {
        const schedules: ISchedule[] = [];

        const event: EventType =
            Object.assign({}, DUMMY_EVENTS[Math.floor(Math.random() * DUMMY_EVENTS.length)]);

        const possibleStartTime = DEFAULT_CALENDAR_CONFIG.businessDayStartHour;
        const possibleEndTime = DEFAULT_CALENDAR_CONFIG.businessDayEndHour;

        let currentHour = possibleStartTime;
        let scheduleIndex = 0;
        while (currentHour < possibleEndTime) {
            let jobEndHours = currentHour + Math.floor(Math.random() * 4) + 1;
            if (jobEndHours > possibleEndTime) {
                jobEndHours = possibleEndTime;
            }
            schedules.push({
                id: String(scheduleIndex++),
                calendarId: '1',
                title: event.description,
                category: 'time',
                dueDateClass: '',
                start: moment(day).hours(currentHour).toDate(),
                end: moment(day).hours(jobEndHours).toDate(),
                raw: {
                    event
                }
            });
            currentHour = jobEndHours + Math.floor(Math.random() * 2) + 1;
        }
        return schedules;
    }

    getTimeLeft(schedules: ISchedule[]): number {
        let timeleft = 0;
        for (const currentSchedule of schedules) {
            const start = moment(currentSchedule.start as Date);
            const end = moment(currentSchedule.end as Date);

            const duration = moment.duration(end.diff(start));
            timeleft = timeleft + duration.asMilliseconds();
        }
        const businessDayWorkingMillis = DEFAULT_CALENDAR_CONFIG.businessDayDurationHours * 60 * 60 * 1000;
        return businessDayWorkingMillis - timeleft;
    }

    /**
     *  Returns all 24 time grid elements
     */
    private findTimeGridElements(): HTMLCollectionOf<Element> {
        return document.getElementsByClassName('tui-full-calendar-timegrid-gridline');
    }
}

const CALENDER_UTILS_INSTANCE = new CalendarUtils();

export {CALENDER_UTILS_INSTANCE};
